import React, { useRef } from 'react';
import { Avatar, Flexbox, Text } from '@morressier/ts';
import { HomeSearchUser } from 'typings/user';
import { typedBoolean } from 'utils/utils';

import { Title, AvatarWrapper, Author } from './style';
import Tooltip from '@morressier/ts/_dist/cjs/cards/Tooltip/index';

interface Props {
  eventName: string | undefined;
  title: string;
  authors: (HomeSearchUser | null | undefined)[];
  onTitleClick?: () => void;
}

const RecentlyReadCard: React.FC<Props> = props => {
  const { title, authors: authorsList, onTitleClick } = props;
  const titleRef = useRef(null);

  const renderAuthors = () => {
    // filter authors by full name
    const authors = authorsList?.filter(author =>
      typedBoolean(author?.full_name)
    );

    const authorsCount = authors.length > 2 ? 1 : 2;
    // Display First two authors and display +n more icons
    const authorAvatars = authors
      .slice(0, authorsCount)
      .map((author, index, allAuthors) => {
        return (
          <Flexbox key={author?.id} alignItems="center">
            <Avatar
              fullName={author?.full_name || author?.email || ''}
              customSize="18px"
              customFontSize="10px"
              src={author?.picture_url ? author.picture_url : null}
              style={{ margin: 0, marginRight: '4px' }}
            />
            <Author>
              {author?.full_name}
              {index < allAuthors.length - 1 && ','}
            </Author>
          </Flexbox>
        );
      });

    if (authors && authorAvatars) {
      const remainingAuthors = authors?.length - authorAvatars?.length;
      if (remainingAuthors > 0 && authorAvatars.length > 0)
        authorAvatars?.push(
          <div style={{ color: 'var(--color-mono-60)' }}>
            {' '}
            and {remainingAuthors} more
          </div>
        );
    }
    return authorAvatars;
  };

  return (
    <div style={{ marginBottom: '2rem' }}>
      {/* @ts-ignore */}
      <Tooltip content={title} childRef={titleRef}>
        <Title onClick={onTitleClick}>
          <div ref={titleRef}>{title}</div>
        </Title>
      </Tooltip>
      <AvatarWrapper>{renderAuthors()}</AvatarWrapper>
    </div>
  );
};

export default RecentlyReadCard;
